import { createContext, useContext } from 'react';

type ExpandedViewContextType = boolean | undefined;

export const ExpandedViewContext = createContext<ExpandedViewContextType>(undefined);

export const useExpandedViewContext = () => {
  const context = useContext(ExpandedViewContext);

  return context;
};
export const ExpandedViewProvider = ExpandedViewContext.Provider;
